<template>
  <div class="h-full relative overflow-auto flex flex-col overflow-x-hidden">
    <div class="sticky top-0 z-[2] bg-white pageHeader">
      <slot name="header">
        <div class="mobile-status-padding"></div>
        <div class="top-0 p-5">
          <div class="text-3xl text-primary text-center font-bold">
            <slot name="headerTitle"> - </slot>
          </div>
        </div>
      </slot>
    </div>
    <div
      class="w-full h-full pageBody pb-32 overflow-auto overflow-x-hidden"
      :style="{ backgroundColor: `${$attrs.bodyBg} !important` }"
    >
      <slot></slot>
    </div>
  </div>
</template>
